import { Box, Typography } from "@mui/material";
import mapKey from "../../../../assets/Images/mapkey.png";
import NoImage from "../../../../assets/Images/no_image.jpg";
import { useEffect, useState } from "react";
import useCustomLogic from "../../../../Hooks/UseCustomLogic";
import { LoaderComponent } from "../../../../components/Loader/LoaderComponent";
import { LazyLoadImage } from "react-lazy-load-image-component";

export const Snapshot = ({ dataState, selectedDistrict, imageLink }) => {
  const { loader } = useCustomLogic();
  const [stateImageSrc, setStateImageSrc] = useState("");
  const [districtImageSrc, setDistrictImageSrc] = useState(NoImage);

  useEffect(() => {
    setStateImageSrc(dataState?.state_image || "");
  }, [dataState?.state_image]);

  useEffect(() => {
    setDistrictImageSrc(imageLink || NoImage);
  }, [imageLink]);

  return (
    <Box>
      {selectedDistrict === "Select District" ? (
        <Box>
          {loader ? (
            <LoaderComponent height="50vh" />
          ) : (
            <>
              <Typography variant="body1">
                The performance of each district court complex is based on equal weightage of nine
                parameters relevant to court infrastructure, i.e., getting there, navigation,
                waiting area, hygiene, barrier- free access, case display, amenities, security and
                website. The darker the shade of the district on the map, the better is the
                aggregate performance of each district court complex and vice-versa.
              </Typography>

              <img src={mapKey} style={{ width: "50%", marginTop: "20px" }} />

              {stateImageSrc && (
                <Box sx={{ maxHeight: "500px", maxWidth: "700px" }}>
                  <LazyLoadImage
                    src={stateImageSrc}
                    placeholderSrc={NoImage}
                    onError={() => setStateImageSrc("")}
                    width={"100%"}
                    style={{
                      width: "100%",
                      maxHeight: "500px",
                      height: "auto",
                    }}
                    preload="auto"
                  />
                </Box>
              )}
            </>
          )}
        </Box>
      ) : (
        <>
          <Box sx={{ maxHeight: "400px" }}>
            <LazyLoadImage
              src={districtImageSrc}
              placeholderSrc={NoImage}
              onError={() => setDistrictImageSrc(NoImage)}
              width={"100%"}
              style={{
                width: "100%",
                maxHeight: "400px",
                height: "auto",
                minHeight: "400px",
              }}
            />
          </Box>

          <Typography variant="body2" color="secondary.main" mt={2}>
            The field researchers were asked to take the photos of court with time stamp for
            purposes of verification only. Some of the photographs may not be of the best quality as
            they were taken from general access areas and may represent a part of the court complex
            where no express permission was required to capture the photograph.
          </Typography>
        </>
      )}
    </Box>
  );
};
